import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, Select, Input, Typography, Row, Col } from 'antd';
import { actionButtonOptions } from './IssueCardUtils';
const { Option } = Select;
const { Text } = Typography;
const IssueCardButtonListItem = ({
  actionButton,
  updateCustomButtons,
  all_issuetype_fields,
  index,
  deleteButtonRow,
  usedButtonActions,
  actionErrors = {},
}) => {
  return (
    <Row gutter={8}>
      <Col span={6}>
        {actionErrors && actionErrors.name ? (
          <div style={{ color: 'red' }}>{actionErrors.name}</div>
        ) : Object.values(actionErrors).length > 0 ? (
          <div>&nbsp;</div>
        ) : (
          ''
        )}
        <Input
          maxLength={55}
          value={actionButton && actionButton.name}
          onChange={(event) =>
            updateCustomButtons(event.target.value, 'name', index)
          }
        />
      </Col>
      <Col span={actionButton.value === 'update_fields' ? 16 : 6}>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '100%' }}>
            {actionErrors && actionErrors.value ? (
              <div style={{ color: 'red' }}>{actionErrors.value}</div>
            ) : Object.values(actionErrors).length > 0 ? (
              <div>&nbsp;</div>
            ) : (
              ''
            )}
            <Select
              style={{ width: '100%' }}
              value={actionButton && actionButton.value}
              onChange={(value) => updateCustomButtons(value, 'value', index)}
            >
              {actionButtonOptions()
                .filter((item) => {
                  if (
                    (item && item.value === 'update_fields') ||
                    item.value === actionButton.value
                  ) {
                    return true;
                  }
                  return !usedButtonActions.includes(item.value);
                })
                .map((el) => {
                  return <Option value={el.value}>{el.name}</Option>;
                })}
            </Select>
          </div>
          {actionButton && actionButton.value === 'update_fields' && (
            <div style={{ marginLeft: '10px' }}>
              {/* {(actionErrors&&actionErrors.field)?<div style={{color:"red"}}>*{actionErrors.field}</div>:<div/>} */}
              {actionErrors && actionErrors.field ? (
                <div style={{ color: 'red' }}>{actionErrors.field}</div>
              ) : Object.values(actionErrors).length > 0 ? (
                <div>&nbsp;</div>
              ) : (
                ''
              )}

              <div>
                <Select
                  maxTagCount='responsive'
                  style={{ width: '320px' }}
                  placeholder='Choose fields to update'
                  mode='multiple'
                  value={actionButton && actionButton.fieldsToUpdate}
                  showSearch
                  optionFilterProp='children'
                  filterOption={(input, option) => {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                  onChange={(value) => {
                    updateCustomButtons(value, 'fieldsToUpdate', index);
                  }}
                >
                  {all_issuetype_fields.map((field) => {
                    return (
                      <Option
                        key={field.fieldId}
                        value={field.fieldId}
                        // disabled={
                        //   buttonActions &&
                        //   buttonActions.button_2 &&
                        //   buttonActions.button_2.fieldId === field.fieldId
                        // }
                      >
                        {field.name}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          )}
        </div>
      </Col>
      <Col span={2}>
        {Object.values(actionErrors).length > 0 ? <div>&nbsp;</div> : ''}

        <Button
          style={{ opacity: '45%', border: 'none' }}
          onClick={() => deleteButtonRow(index)}
          icon={<DeleteOutlined />}
        />
      </Col>
    </Row>
  );
};

export default IssueCardButtonListItem;
